export const DASHBOARD_DELETE_ACTION = 'deleted';
export const DASHBOARD_UPDATE_ACTION = 'updated';
export const DASHBOARD_CREATE_ACTION = 'created';
export const WIDGET_LABEL_SINGULAR = 'widget';
export const WIDGET_LABEL_PLURAL = 'widgets';
export const SOURCE_TYPE_DASHBOARD = 'dashboard';
